// src/App.js
import React, { useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Bio from './components/Bio';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import profile from './profile.jpg';

function App() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('section');
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <header className="hero" id="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-heading">
              Hi, I'm <span className="hero-name">Avi</span>. I build AI products and lead technical consulting teams.
            </h1>
            <p className="hero-subtext">
              UC Berkeley CS student building AI/ML products and working with startups on technical consulting projects.
            </p>
            <div className="hero-cta">
              <a href="#projects" className="btn btn-primary">View my work</a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">5+</span>
                <span className="stat-label">consulting projects</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">AI & ML builds</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">$100K+</span>
                <span className="stat-label">raised for student org</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-gradient-blob"></div>
            <div className="hero-avatar">
              <img src={profile} alt="Avi Desai" />
            </div>
          </div>
        </div>
      </header>

      <main className="App-main">
        <section id="about" className="fade-in-section">
          <Bio />
        </section>
        <section id="experience" className="fade-in-section">
          <Experience />
        </section>
        <section id="projects" className="fade-in-section">
          <Projects />
        </section>
        <section id="contact" className="fade-in-section">
          <Contact />
        </section>
      </main>
    </div>
  );
}

export default App;
